<template>
  <div class="popUpWrap">
    <section class="popup dark assessment">
      <div class="topArea"></div>
      <div class="scrollY">
        <div class="icon rec"></div>
        <div class="textArea flex">
          <h5 v-html="convertToNextLine(t('skillCertify-proctoring-recording-fail-title'))"></h5>
        </div>
        <div class="boxArea">
          <ul class="listDot">
            <li>{{ t("skillCertify-proctoring-recording-fail-description") }}</li>
            <li v-if="externalDirectorService.isMac" v-html="convertToNextLine(t('skillCertify-proctoring-entire-screen-recording-no-access-description-1') + '<br/>' + t('learning-assessment-guide-line-description-for-mac-2') + '<span>' + t(externalDirectorService.isCodepressoWebview ? 'learning-assessment-guide-line-description-for-mac-4' : 'learning-assessment-guide-line-description-for-mac-3') + '</span>')"></li>
            <li>{{ t("skillCertify-proctoring-entire-screen-recording-no-access-description-2") }}</li>
          </ul>
        </div>
        <p class="contactText" v-html="t('skillCertify-proctoring-entire-screen-recording-no-access-description-3', { email: supportEmailHtml })"></p>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted , convertToNextLine, useI18n } from '#imports';

import { useExternalDirectorService } from "~/composables/service/useExternalDirectorService";

const { t } = useI18n();
const externalDirectorService = useExternalDirectorService();
const supportEmailHtml = '<a href="mailto:support@codepresso.io">support@codepresso.io</a>';

const handleKeyDown = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    event.preventDefault();
    event.stopPropagation();
  }
};

onMounted(() => {
  window.addEventListener('keydown', handleKeyDown);
});

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeyDown);
});
</script>

<style scoped>
.contactText {
  margin-top: 16px;
}
</style>

